import * as React from "react";
import { useEffect } from "react";
import {
  DataGrid,
  GridRowsProp,
  GridColDef,
  faIR,
  GridToolbar,
  GridCheckIcon,
  GridDeleteIcon,
} from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid, IconButton, Button } from "@mui/material";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import AcUnitTwoToneIcon from "@mui/icons-material/CallToAction";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { setinitialStateR } from "../../../components/Login/LoginSlice/LoginSlice";
import "./style.css";
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";

//  export default function CustomToolbarGrid() {
//       const { data } = useDemoData({
//         dataSet: 'Commodity',
//         rowLength: 10,
//         maxColumns: 6,
//       });
// setShowToolbarModal={setShowModal}
// showInformation={showModal}

export default function DyDataGridCs({
  data = [],
  columns = [],
  hideFooter,
  selectionModel,
  initialOnRowClick,
  rowSelection,
  rowHeight,
  onRowSelectionEvent,
  initState,
  setSelectionModel,
  setShowHistory,
  additionalToolbar,
  setShowInformation,
  setSpecialId,
  setShowAddEvalModal,
  initialDelete,
  initialAccept,
  setShowActionsModal,
  initialMount,
  setPointSys,
  drName,
  setRowSelectedData,
  withoutOptions,
}: any) {
  const [selectedRowData, setSelectedRowData] = React.useState(null);
  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <Grid>
          {/* {selectedRowData && additionalToolbar && (
            <Button
              sx={{ fontSize: "10px" }}
              variant="text"
              onClick={() => {
                setShowHistory((prev: any) => !prev);
                let { id } = selectedRowData;
                setSpecialId(id);
              }}
              startIcon={<HistoryToggleOffIcon />}
            >
              ویرایش
            </Button>
          )} */}
          
          {/* {selectedRowData && additionalToolbar && (
            <Button
              sx={{ fontSize: "10px" }}
              variant="text"
              onClick={() => {
                let { id } = selectedRowData;
                setSpecialId(id);
                initialDelete();
              }}
              startIcon={<GridDeleteIcon />}
            >
              حذف
            </Button>
          )} */}
          {/* {selectedRowData && additionalToolbar && (
            <Button
              sx={{ fontSize: "10px" }}
              variant="text"
              onClick={() => {
                let { id } = selectedRowData;
                setSpecialId(id);
                initialAccept();
              }}
              startIcon={<GridCheckIcon />}
            >
              تایید
            </Button>
          )} */}
         
        </Grid>
        <GridToolbarColumnsButton sx={{ display: { xs: 'none', sm: 'inline-flex' } }} />
<GridToolbarFilterButton sx={{ display: { xs: 'none', sm: 'inline-flex' } }} />
<GridToolbarDensitySelector sx={{ display: { xs: 'none', sm: 'inline-flex' } }} />

      </GridToolbarContainer>
    );
  }

  const initOnRowClick = (row: any) => {
    setSelectionModel(row.id);
    setSelectedRowData(row);
    initialOnRowClick(row);
    if (setPointSys) {
      setPointSys(row?.okR_KeyResultType);
    }
    if (setRowSelectedData) {
      setRowSelectedData(row);
    }
  };

  useEffect(() => {
    if (initialMount) {
      setSelectedRowData(data[0]);
      initialOnRowClick(data[0]);
    }

    if (setPointSys) {
      setPointSys(data[0]?.okR_KeyResultType);
    }

    if (setRowSelectedData) {
      setRowSelectedData(data[0]);
    }
  }, []);

  const dispatch = useDispatch();

  const initialChangestate = (data: any) => {
    if (drName && data) {
      let columnVisibilityModel = data?.columns?.columnVisibilityModel;
      try {
        dispatch(
          setinitialStateR({ name: drName, colVis: columnVisibilityModel })
        );
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <Grid width={"100%"}>
      <DataGrid
        onStateChange={(state) => {
          initialChangestate(state);
        }}
        density="compact"
        initialState={initState}
        slots={{ toolbar: withoutOptions ? null : CustomToolbar }}
        rowHeight={40}
        sx={{
          cursor: "pointer",
          border: 0,
          "& .MuiDataGrid-columnSeparator": {
            display: "none!important",
          },
          "& .MuiDataGrid-root": {
            backgroundColor: "#00387C !important",
            color: "white",
            borderRadius: 4,
            cursor: "pointer",
            border: 0,
            "& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell": {
              fontSize: "10px", // Adjust the font size as needed
            },
            "& .rtl-128fb87-MuiDataGrid-toolbarContainer": {
              alignSelf: "end",
              pb: 2,
            },
          },
          "& .MuiDataGrid-columnHeaders": {
            width: "100%",
            position: "sticky",
            zIndex: "1000",
            background: "#00387C !important",
            color: "white",
          },
          // "& .MuiDataGrid-row:nth-of-type(odd)": {
          //   backgroundColor: "#f5f5f5",  // رنگ پس‌زمینه برای سطرهای فرد
          // },
          // "& .MuiDataGrid-row:nth-of-type(even)": {
          //   backgroundColor: "#ffffff",  // رنگ پس‌زمینه برای سطرهای زوج
          // },
        }}
        hideFooter={hideFooter}
        autoHeight
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        rowSelectionModel={selectionModel}
        rows={data ? data : []}
        columns={columns}
        disableColumnMenu
        checkboxSelection={rowSelection ? rowSelection : false}
        rowSelection={true}
        onRowClick={(param) => {
          initOnRowClick(param.row);
        }}
      />
    </Grid>
  );
}
